import { API } from "@swivl-mono/api-helper";
import { TicketPreview } from "@swivl-mono/types";
import { useEffect, useState } from "react";

import { TicketListItem } from "./TicketListItem";
import { lockableClick } from "./fields/TicketPropertyRow";

interface AccessRelatedTicketsListProps {
  token: string;
  currentTicketId: number;
}

// Every ticket this recipient has a link for, not the org's inbox.
export function AccessRelatedTicketsList({ token, currentTicketId }: AccessRelatedTicketsListProps) {
  const [tickets, setTickets] = useState<TicketPreview[]>([]);

  useEffect(() => {
    void API.TicketingAccess.getRelatedTickets(token).then((res) => {
      // Current ticket first, so it's visible without scrolling.
      const sorted = [...res.tickets].sort((a, b) => (a.id === currentTicketId ? -1 : b.id === currentTicketId ? 1 : 0));
      setTickets(sorted);
    });
  }, [token, currentTicketId]);

  return (
    <div className="flex min-h-0 flex-col overflow-hidden rounded-lg border border-grey-200 bg-white">
      <div className="flex h-12 shrink-0 items-center border-b border-grey-200 px-4">
        <span className="heading-base-alt text-black">Your Tickets</span>
      </div>
      <div className="min-h-0 flex-1 space-y-1 overflow-auto p-2">
        {tickets.map((ticket) => {
          const isCurrent = ticket.id === currentTicketId;
          return (
            <TicketListItem
              key={ticket.id}
              ticket={ticket}
              isSelected={isCurrent}
              locked={!isCurrent}
              hideAccept
              onClick={lockableClick(!isCurrent, "Managing tickets", () => {})}
              onAccept={() => {}}
            />
          );
        })}
      </div>
    </div>
  );
}
